import { Dispatch, SetStateAction } from "react";
import Modal from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import { ModalContent } from "./ModalContent";
import { GalleryImageObject, GalleryVideoObject } from "../../utils";
import styles from "./ZoomModal.module.scss";
import { dispatchGalleryMonetateQEvent } from "../Analytics/dispatchGalleryMonetateQEvent";

export interface ZoomModalProps {
  mode?: "image" | "video";
  showZoomModal: boolean;
  closeZoomModal: () => void;
  images: GalleryImageObject[];
  videos: GalleryVideoObject[];
  setSelectedIndex: Dispatch<SetStateAction<number>>;
  selectedIndex: number;
}
export const ZoomModal = ({
  mode = "image",
  showZoomModal,
  closeZoomModal,
  images,
  videos,
  setSelectedIndex,
  selectedIndex,
}: ZoomModalProps) => {
  const handleCloseZoomModal = () => {
    dispatchGalleryMonetateQEvent("CloseModal", `${mode}Modal`);
    closeZoomModal();
  };

  return (
    <Modal
      isOpen={showZoomModal}
      fullscreen
      onClose={handleCloseZoomModal}
      className={styles.modalContainer}
      hasPadding={false}
      closeButtonClassName={styles.closeIcon}
    >
      <ModalContent
        mode={mode}
        images={images}
        videos={videos}
        setSelectedIndex={setSelectedIndex}
        selectedIndex={selectedIndex}
      />
    </Modal>
  );
};
